export const siteBrand = "31黑料网";

export const navLinks = [
  { label: "黑料专题", href: "#topics" },
  { label: "黑料专区", href: "#zones" },
  { label: "黑料频道", href: "#channels" },
  { label: "黑料导航", href: "#nav" },
  { label: "下载入口", href: "#download" },
];

export const tickerItems = [
  "黑料专题总汇更新至第 18 期",
  "网红直播专区新增 6 条脉络梳理",
  "商业观察频道已补齐事件时间线",
  "体育赛场专区上线赛后未删减片段",
  "热度排行今日刷新",
  "黑料导航新增 4 个直达入口",
];

export const heroStats = [
  { value: "2,860", suffix: "+", label: "黑料专题收录" },
  { value: "48", suffix: "", label: "今日实时更新" },
  { value: "12", suffix: "", label: "黑料频道覆盖" },
  { value: "36", suffix: "", label: "黑料专区直达" },
];

export const quickEntries = [
  { label: "黑料专区", href: "#zones", icon: "ri-folder-open-line" },
  { label: "黑料频道", href: "#channels", icon: "ri-live-line" },
  { label: "黑料导航", href: "#nav", icon: "ri-compass-3-line" },
  { label: "下载入口", href: "#download", icon: "ri-download-2-line" },
];

export const updateFeed = [
  { time: "09:12", tag: "娱乐", title: "某综艺名场面合集专题更新至第 18 期", heat: "2.4w", type: "专题" },
  { time: "08:47", tag: "网红", title: "直播间争议事件脉络梳理完毕", heat: "1.7w", type: "专区" },
  { time: "08:20", tag: "商业", title: "品牌翻车时间线与回应汇总", heat: "9863", type: "频道" },
  { time: "07:55", tag: "体育", title: "赛后采访未删减片段整理上线", heat: "7421", type: "专题" },
  { time: "07:30", tag: "社会", title: "公共事件多方说法对照页更新", heat: "6180", type: "专区" },
  { time: "06:58", tag: "科技", title: "发布会翻车集锦栏目新增 9 条", heat: "5032", type: "频道" },
];

export const topics = [
  {
    id: "t1",
    category: "娱乐",
    badge: "编辑推荐",
    title: "年度娱乐黑料专题总汇",
    desc: "把散落在各频道的名场面与争议话题整理成一份可追更的目录，点开就是完整脉络。",
    count: "128 条内容",
    heat: "9.8w",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20editorial%20stage%20spotlight%20beams%20crossing%20empty%20space%20with%20crimson%20haze%20and%20amber%20glow%2C%20film%20grain%20texture%2C%20cinematic%20minimal%20composition%2C%20high%20contrast%2C%20no%20people&width=900&height=700&seq=hl-topic-01&orientation=landscape",
  },
  {
    id: "t2",
    category: "网红",
    badge: "热度上升",
    title: "直播争议事件追踪专题",
    desc: "按时间顺序还原每次争议的起因、回应与后续，适合想一次看清前因后果的人。",
    count: "96 条内容",
    heat: "7.3w",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20neon%20night%20alley%20with%20amber%20and%20crimson%20reflections%20on%20wet%20dark%20surface%2C%20film%20grain%2C%20moody%20editorial%20abstract%20photography%2C%20deep%20shadows%2C%20no%20people&width=900&height=700&seq=hl-topic-02&orientation=landscape",
  },
  {
    id: "t3",
    category: "商业",
    badge: "长文合集",
    title: "品牌翻车复盘专题",
    desc: "从产品宣传到公众回应逐条对照，把每一份公开说明都放进同一条时间线里比对。",
    count: "74 条内容",
    heat: "5.6w",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stacked%20papers%20and%20light%20streaks%20on%20dark%20desk%20with%20crimson%20accent%20glow%2C%20film%20grain%20texture%2C%20editorial%20minimal%20still%20life%2C%20no%20people&width=900&height=700&seq=hl-topic-03&orientation=landscape",
  },
  {
    id: "t4",
    category: "体育",
    badge: "本周新增",
    title: "赛后采访未删减合集",
    desc: "收录赛场之外的采访片段与场边镜头，补全直播里没来得及播出的部分。",
    count: "61 条内容",
    heat: "4.1w",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20silhouette%20of%20a%20microphone%20under%20warm%20spotlight%20on%20dark%20stage%2C%20crimson%20backlight%2C%20film%20grain%2C%20cinematic%20moody%20editorial%20abstract%2C%20no%20people&width=900&height=700&seq=hl-topic-04&orientation=landscape",
  },
];

export const zones = [
  {
    name: "娱乐圈专区",
    desc: "综艺、影视与活动现场的高热话题集中地。",
    count: "312 条",
    icon: "ri-film-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20film%20reel%20and%20warm%20projector%20light%20on%20dark%20charcoal%20background%2C%20crimson%20amber%20glow%2C%20film%20grain%2C%20minimal%20editorial%20abstract%20still%20life&width=800&height=600&seq=hl-zone-01&orientation=landscape",
  },
  {
    name: "网红直播专区",
    desc: "直播现场与短视频争议的脉络梳理。",
    count: "248 条",
    icon: "ri-live-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20ring%20light%20and%20camera%20lens%20with%20amber%20crimson%20reflections%20on%20dark%20studio%20surface%2C%20film%20grain%2C%20moody%20minimal%20editorial%20abstract&width=800&height=600&seq=hl-zone-02&orientation=landscape",
  },
  {
    name: "商业观察专区",
    desc: "品牌风波与商业事件的公开信息比对。",
    count: "176 条",
    icon: "ri-bar-chart-box-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20statistics%20chart%20lines%20on%20dark%20panel%20with%20crimson%20accent%2C%20film%20grain%20texture%2C%20clean%20minimal%20editorial%20abstract&width=800&height=600&seq=hl-zone-03&orientation=landscape",
  },
  {
    name: "体育赛场专区",
    desc: "赛场内外的镜头、采访与场边瞬间。",
    count: "203 条",
    icon: "ri-basketball-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stadium%20floodlights%20and%20empty%20arena%20haze%20on%20dark%20background%2C%20amber%20crimson%20glow%2C%20film%20grain%2C%20cinematic%20minimal%20editorial%20abstract&width=800&height=600&seq=hl-zone-04&orientation=landscape",
  },
  {
    name: "科技发布专区",
    desc: "新品发布会与产品翻车的现场记录。",
    count: "154 条",
    icon: "ri-cpu-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20circuit%20board%20and%20light%20trails%20on%20dark%20surface%20with%20crimson%20amber%20reflections%2C%20film%20grain%2C%20sharp%20minimal%20editorial%20abstract&width=800&height=600&seq=hl-zone-05&orientation=landscape",
  },
  {
    name: "社会热点专区",
    desc: "公共事件的多方说法与时间线对照。",
    count: "229 条",
    icon: "ri-earth-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20city%20skyline%20silhouette%20in%20dense%20fog%20at%20night%20with%20amber%20crimson%20glow%2C%20film%20grain%2C%20moody%20minimal%20editorial%20abstract&width=800&height=600&seq=hl-zone-06&orientation=landscape",
  },
];

export const channels = [
  { icon: "ri-mic-line", name: "爆料频道", desc: "第一时间收录最新爆料条目", count: "128 条", tag: "更新最快" },
  { icon: "ri-route-line", name: "追踪频道", desc: "按时间线持续跟进事件走向", count: "96 条", tag: "脉络完整" },
  { icon: "ri-article-line", name: "长文频道", desc: "深度复盘与多方说法对照", count: "74 条", tag: "深度解读" },
  { icon: "ri-image-2-line", name: "图集频道", desc: "现场截图与画面对映整理", count: "163 条", tag: "图多好翻" },
  { icon: "ri-vidicon-line", name: "视频频道", desc: "未删减片段与现场录像归档", count: "88 条", tag: "原片留存" },
  { icon: "ri-fire-line", name: "排行频道", desc: "按热度与更新刷新推荐位", count: "52 条", tag: "每日刷新" },
];

export const navEntries = [
  { icon: "ri-bookmark-3-line", label: "黑料专题", desc: "可追更的专题目录", tag: "推荐" },
  { icon: "ri-folder-open-line", label: "黑料专区", desc: "按领域分类的专区入口", tag: "常用" },
  { icon: "ri-live-line", label: "黑料频道", desc: "持续更新的内容频道", tag: "实时" },
  { icon: "ri-layout-grid-line", label: "黑料栏目", desc: "按栏目归集的页面", tag: "" },
  { icon: "ri-fire-line", label: "热度排行", desc: "今日最热条目清单", tag: "榜单" },
  { icon: "ri-hashtag", label: "标签导航", desc: "用标签快速定位内容", tag: "" },
  { icon: "ri-calendar-2-line", label: "更新日历", desc: "按日期回看每日收录", tag: "新" },
  { icon: "ri-notification-3-line", label: "订阅入口", desc: "订阅后更新不错过", tag: "" },
];

export const downloadButtons = [
  { icon: "ri-apple-fill", label: "iOS 版下载", sub: "App Store" },
  { icon: "ri-android-fill", label: "Android 版下载", sub: "APK 直装" },
];

export const footerColumns = [
  {
    title: "内容导航",
    links: ["黑料专题", "黑料专区", "黑料频道", "黑料栏目", "黑料导航"],
  },
  {
    title: "关于本站",
    links: ["网站简介", "收录说明", "更新日志", "联系方式"],
  },
  {
    title: "帮助中心",
    links: ["常见问题", "内容申诉", "意见反馈", "免责声明"],
  },
];